/**
 * ユーザー情報統合 Hook
 * UserContext を使用してユーザー情報にアクセス
 */

import { useContext } from 'react';
import { UserContext } from '@/contexts/userContextObj';
import type { UserContextType } from '@/contexts/UserContext';

/**
 * ユーザー情報を使用するカスタムフック
 * プロフィールとサブスクリプション情報を統合して提供
 */
export const useUser = (): UserContextType => {
  const context = useContext(UserContext);
  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }
  return context;
};
